import { IsNullOrEmpty } from 'utils/StringNullOrEmpty';

export const Percentage = (value?: string | number) => {
  if (IsNullOrEmpty(value)) return "-";

  return `${value?.toString().substring(0,5)} %`;
};

export const PercentageWith4Digits = (value: string | number) => {
  if (IsNullOrEmpty(value)) return "-";

  const formattedValue = parseFloat(value.toString()).toFixed(4);
  return `${formattedValue} %`;
};